import React from 'react';
import { Link } from 'react-router-dom';
import { setItem } from '../../redux/cart/slice';
import { useAppDispatch } from '../../redux/store';
type PizzaBlockProps = {
	id: string;
	imageUrl: string;
	title: string;
	types: number[];
	sizes: number[];
	price: number;
}
const PizzaBlock: React.FC<PizzaBlockProps> = ({ id, title, price, imageUrl, types, sizes }) => {
	const typeNames: string[] = ['тонкі', 'традиційне'];

	const [activeType, setActiveType] = React.useState(0);
	const [activeSize, setActiveSize] = React.useState(0);

	const dispatch = useAppDispatch();
	const clickAddItem = () => {
		const item = {
			id,
			imageUrl,
			title,
			price,
			type: typeNames[activeType],
			size: sizes[activeSize],
			count: 1,
		};
		dispatch(setItem(item));
	};
	return (
		<div className="pizza-block">
			<Link to={`pizza/${id}`}>
				<img className="pizza-block__image" src={imageUrl} alt="Pizza" />
			</Link>

			<h4 className="pizza-block__title">{title ? title : 'Чизбуогео піцца'}</h4>
			<div className="pizza-block__selector">
				<ul>
					{types.map((index) => (
						<li
							onClick={() => setActiveType(index)}
							key={index}
							className={activeType === index ? 'active' : 'pizza-item'}>
							{typeNames[index]}
						</li>
					))}
				</ul>
				<ul>
					{sizes.map((value, index) => (
						<li
							onClick={() => setActiveSize(index)}
							key={index + value}
							className={activeSize === index ? 'active' : 'pizza-item'}>
							{value} см.
						</li>
					))}
				</ul>
			</div>
			<div className="pizza-block__bottom">
				<div className="pizza-block__price">від {price ? price : ' 395'} ₴</div>
				<button onClick={() => clickAddItem()} className="button button--outline button--add">
					<svg
						width="12"
						height="12"
						viewBox="0 0 12 12"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M10.8 4.8H7.2V1.2C7.2 0.5373 6.6627 0 6 0C5.3373 0 4.8 0.5373 4.8 1.2V4.8H1.2C0.5373 4.8 0 5.3373 0 6C0 6.6627 0.5373 7.2 1.2 7.2H4.8V10.8C4.8 11.4627 5.3373 12 6 12C6.6627 12 7.2 11.4627 7.2 10.8V7.2H10.8C11.4627 7.2 12 6.6627 12 6C12 5.3373 11.4627 4.8 10.8 4.8Z"
							fill="white"
						/>
					</svg>
					<span>Добавити</span>
				</button>
			</div>
		</div>
	);
};
export default PizzaBlock;
